import GGVarFlavorInsights from './GGVarFlavorInsights';
export default GGVarFlavorInsights;
